import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

import "./DepositCrypto.css";

/*
|--------------------------------------------------------------------------
| CRYPTO DEPOSIT METHODS
|--------------------------------------------------------------------------
*/

const DEPOSIT_METHODS = [
  {
    id: "TRC20",
    name: "Tether (USDT)",
    network: "TRC-20",
    coin: "USDT",
    field: "trc20Address",
    walletKey: "TRC20",
    min: 10,
    className: "deposit-usdt",
  },

  {
    id: "TRON_TRX",
    name: "Tron",
    network: "TRON",
    coin: "TRX",
    field: "trxAddress",
    walletKey: "TRON_TRX",
    min: 10,
    className: "deposit-trx",
  },

  {
    id: "ERC20",
    name: "Ethereum",
    network: "ERC-20",
    coin: "ETH",
    field: "erc20Address",
    walletKey: "ERC20",
    min: 10,
    className: "deposit-eth",
  },

  {
    id: "BNB_BEP20",
    name: "BNB Smart Chain",
    network: "BEP20 BSC",
    coin: "BNB",
    field: "bep20Address",
    walletKey: "BNB_BEP20",
    min: 10,
    className: "deposit-bnb",
  },

  {
    id: "BITCOIN",
    name: "Bitcoin",
    network: "BTC",
    coin: "BTC",
    field: "bitcoinAddress",
    walletKey: "BITCOIN",
    min: 10,
    className: "deposit-btc",
  },

  {
    id: "SOLANA",
    name: "Solana",
    network: "SOLANA",
    coin: "SOL",
    field: "solanaAddress",
    walletKey: "SOLANA",
    min: 10,
    className: "deposit-sol",
  },
];

/*
|--------------------------------------------------------------------------
| COIN LOGO
|--------------------------------------------------------------------------
*/

const CoinLogo = ({ type }) => {
  const common = {
    width: 42,
    height: 42,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
  };

  if (type === "USDT") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="18" fill="#26A17B" />

        <path
          d="M10 10.5H30V15H23V27.5H17V15H10V10.5Z"
          fill="white"
        />

        <path
          d="M20 15C25 15 29 16 29 17.5C29 19 25 20 20 20C15 20 11 19 11 17.5C11 16 15 15 20 15Z"
          fill="#26A17B"
        />

        <path
          d="M20 20V29"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "TRX") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="18" fill="#EC1C24" />

        <path
          d="M10 10L30 13L22 30L10 10Z"
          fill="white"
        />

        <path
          d="M10 10L22 18L30 13"
          stroke="#EC1C24"
          strokeWidth="1.5"
        />

        <path
          d="M22 18L22 30"
          stroke="#EC1C24"
          strokeWidth="1.5"
        />
      </svg>
    );
  }

  if (type === "ETH") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="18" fill="#627EEA" />

        <path
          d="M20 6L12.5 20L20 24.5L27.5 20L20 6Z"
          fill="white"
        />

        <path
          d="M20 25.8L12.5 21.5L20 34L27.5 21.5L20 25.8Z"
          fill="white"
          opacity="0.7"
        />
      </svg>
    );
  }

  if (type === "BNB") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="18" fill="#F3BA2F" />

        <path
          d="M20 8L24 12L20 16L16 12L20 8Z"
          fill="#111827"
        />

        <path
          d="M13 15L16 18L13 21L10 18L13 15Z"
          fill="#111827"
        />

        <path
          d="M27 15L30 18L27 21L24 18L27 15Z"
          fill="#111827"
        />

        <path
          d="M20 15L25 20L20 25L15 20L20 15Z"
          fill="#111827"
        />

        <path
          d="M20 24L24 28L20 32L16 28L20 24Z"
          fill="#111827"
        />
      </svg>
    );
  }

  if (type === "BTC") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="18" fill="#F7931A" />

        <text
          x="20"
          y="27"
          textAnchor="middle"
          fontSize="22"
          fontWeight="900"
          fill="white"
          fontFamily="Arial"
        >
          ₿
        </text>
      </svg>
    );
  }

  if (type === "SOL") {
    return (
      <svg {...common}>
        <defs>
          <linearGradient
            id="solGradientCrypto"
            x1="5"
            y1="5"
            x2="35"
            y2="35"
          >
            <stop offset="0%" stopColor="#00FFA3" />
            <stop offset="100%" stopColor="#9945FF" />
          </linearGradient>
        </defs>

        <circle
          cx="20"
          cy="20"
          r="18"
          fill="#111827"
        />

        <path
          d="M10 13H29L25.5 16.5H10L13.5 13Z"
          fill="url(#solGradientCrypto)"
        />

        <path
          d="M11 19H30L26.5 22.5H11L14.5 19Z"
          fill="url(#solGradientCrypto)"
        />

        <path
          d="M10 25H29L25.5 28.5H10L13.5 25Z"
          fill="url(#solGradientCrypto)"
        />
      </svg>
    );
  }

  return null;
};

/*
|--------------------------------------------------------------------------
| DEPOSIT CRYPTO PAGE
|--------------------------------------------------------------------------
*/


// UI translations for the 30 supported languages.
const TRANSLATIONS = {
  "en": {
    "notLoggedIn": "You are not logged in.",
    "accountNotFound": "User account was not found.",
    "failedLoad": "Failed to load your account.",
    "loadingAccount": "Loading account...",
    "title": "Crypto Deposit",
    "subtitle": "Choose your crypto deposit method",
    "secure": "Secure",
    "min": "Min:",
    "walletReady": "Wallet Ready"
  },
  "fr": {
    "notLoggedIn": "Vous n’êtes pas connecté.",
    "accountNotFound": "Compte utilisateur introuvable.",
    "failedLoad": "Échec du chargement de votre compte.",
    "loadingAccount": "Chargement du compte...",
    "title": "Dépôt crypto",
    "subtitle": "Choisissez votre méthode de dépôt crypto",
    "secure": "Sécurisé",
    "min": "Min. :",
    "walletReady": "Portefeuille prêt"
  },
  "sw": {
    "notLoggedIn": "Hujaingia kwenye akaunti.",
    "accountNotFound": "Akaunti ya mtumiaji haikupatikana.",
    "failedLoad": "Imeshindwa kupakia akaunti yako.",
    "loadingAccount": "Inapakia akaunti...",
    "title": "Amana ya Crypto",
    "subtitle": "Chagua njia ya kuweka crypto",
    "secure": "Salama",
    "min": "Kiwango cha chini:",
    "walletReady": "Wallet iko tayari"
  },
  "pt": {
    "notLoggedIn": "Você não está conectado.",
    "accountNotFound": "A conta do usuário não foi encontrada.",
    "failedLoad": "Falha ao carregar sua conta.",
    "loadingAccount": "Carregando conta...",
    "title": "Depósito de cripto",
    "subtitle": "Escolha seu método de depósito de cripto",
    "secure": "Seguro",
    "min": "Mín.:",
    "walletReady": "Carteira pronta"
  },
  "es": {
    "notLoggedIn": "No has iniciado sesión.",
    "accountNotFound": "No se encontró la cuenta de usuario.",
    "failedLoad": "No se pudo cargar tu cuenta.",
    "loadingAccount": "Cargando cuenta...",
    "title": "Depósito de criptomonedas",
    "subtitle": "Elige tu método de depósito de criptomonedas",
    "secure": "Seguro",
    "min": "Mín.:",
    "walletReady": "Billetera lista"
  },
  "ar": {
    "notLoggedIn": "لم تسجل الدخول.",
    "accountNotFound": "لم يتم العثور على حساب المستخدم.",
    "failedLoad": "تعذر تحميل حسابك.",
    "loadingAccount": "جارٍ تحميل الحساب...",
    "title": "إيداع العملات المشفرة",
    "subtitle": "اختر طريقة إيداع العملات المشفرة",
    "secure": "آمن",
    "min": "الحد الأدنى:",
    "walletReady": "المحفظة جاهزة"
  },
  "zh": {
    "notLoggedIn": "您尚未登录。",
    "accountNotFound": "未找到用户账户。",
    "failedLoad": "无法加载您的账户。",
    "loadingAccount": "正在加载账户...",
    "title": "加密货币充值",
    "subtitle": "选择您的加密货币充值方式",
    "secure": "安全",
    "min": "最低：",
    "walletReady": "钱包已就绪"
  },
  "hi": {
    "notLoggedIn": "आप लॉग इन नहीं हैं।",
    "accountNotFound": "उपयोगकर्ता खाता नहीं मिला।",
    "failedLoad": "आपका खाता लोड नहीं हो सका।",
    "loadingAccount": "खाता लोड हो रहा है...",
    "title": "क्रिप्टो जमा",
    "subtitle": "अपनी क्रिप्टो जमा विधि चुनें",
    "secure": "सुरक्षित",
    "min": "न्यूनतम:",
    "walletReady": "वॉलेट तैयार"
  },
  "bn": {
    "notLoggedIn": "আপনি লগ ইন করেননি।",
    "accountNotFound": "ব্যবহারকারীর অ্যাকাউন্ট পাওয়া যায়নি।",
    "failedLoad": "আপনার অ্যাকাউন্ট লোড করা যায়নি।",
    "loadingAccount": "অ্যাকাউন্ট লোড হচ্ছে...",
    "title": "ক্রিপ্টো জমা",
    "subtitle": "আপনার ক্রিপ্টো জমার পদ্ধতি বেছে নিন",
    "secure": "নিরাপদ",
    "min": "সর্বনিম্ন:",
    "walletReady": "ওয়ালেট প্রস্তুত"
  },
  "ru": {
    "notLoggedIn": "Вы не вошли в систему.",
    "accountNotFound": "Аккаунт пользователя не найден.",
    "failedLoad": "Не удалось загрузить ваш аккаунт.",
    "loadingAccount": "Загрузка аккаунта...",
    "title": "Пополнение криптовалюты",
    "subtitle": "Выберите способ пополнения криптовалюты",
    "secure": "Безопасно",
    "min": "Мин.:",
    "walletReady": "Кошелёк готов"
  },
  "de": {
    "notLoggedIn": "Sie sind nicht angemeldet.",
    "accountNotFound": "Benutzerkonto wurde nicht gefunden.",
    "failedLoad": "Ihr Konto konnte nicht geladen werden.",
    "loadingAccount": "Konto wird geladen...",
    "title": "Krypto-Einzahlung",
    "subtitle": "Wählen Sie Ihre Krypto-Einzahlungsmethode",
    "secure": "Sicher",
    "min": "Min.:",
    "walletReady": "Wallet bereit"
  },
  "it": {
    "notLoggedIn": "Non hai effettuato l’accesso.",
    "accountNotFound": "Account utente non trovato.",
    "failedLoad": "Impossibile caricare il tuo account.",
    "loadingAccount": "Caricamento account...",
    "title": "Deposito crypto",
    "subtitle": "Scegli il metodo di deposito crypto",
    "secure": "Sicuro",
    "min": "Min.:",
    "walletReady": "Wallet pronto"
  },
  "nl": {
    "notLoggedIn": "Je bent niet ingelogd.",
    "accountNotFound": "Gebruikersaccount niet gevonden.",
    "failedLoad": "Je account kon niet worden geladen.",
    "loadingAccount": "Account laden...",
    "title": "Crypto storten",
    "subtitle": "Kies je crypto-stortingsmethode",
    "secure": "Veilig",
    "min": "Min.:",
    "walletReady": "Wallet gereed"
  },
  "tr": {
    "notLoggedIn": "Giriş yapmadınız.",
    "accountNotFound": "Kullanıcı hesabı bulunamadı.",
    "failedLoad": "Hesabınız yüklenemedi.",
    "loadingAccount": "Hesap yükleniyor...",
    "title": "Kripto yatırma",
    "subtitle": "Kripto yatırma yönteminizi seçin",
    "secure": "Güvenli",
    "min": "Min.:",
    "walletReady": "Cüzdan hazır"
  },
  "ja": {
    "notLoggedIn": "ログインしていません。",
    "accountNotFound": "ユーザーアカウントが見つかりません。",
    "failedLoad": "アカウントを読み込めませんでした。",
    "loadingAccount": "アカウントを読み込み中...",
    "title": "暗号資産の入金",
    "subtitle": "暗号資産の入金方法を選択してください",
    "secure": "安全",
    "min": "最低：",
    "walletReady": "ウォレット準備完了"
  },
  "ko": {
    "notLoggedIn": "로그인되어 있지 않습니다.",
    "accountNotFound": "사용자 계정을 찾을 수 없습니다.",
    "failedLoad": "계정을 불러오지 못했습니다.",
    "loadingAccount": "계정을 불러오는 중...",
    "title": "암호화폐 입금",
    "subtitle": "암호화폐 입금 방법을 선택하세요",
    "secure": "안전",
    "min": "최소:",
    "walletReady": "지갑 준비 완료"
  },
  "vi": {
    "notLoggedIn": "Bạn chưa đăng nhập.",
    "accountNotFound": "Không tìm thấy tài khoản người dùng.",
    "failedLoad": "Không thể tải tài khoản của bạn.",
    "loadingAccount": "Đang tải tài khoản...",
    "title": "Nạp tiền mã hóa",
    "subtitle": "Chọn phương thức nạp tiền mã hóa",
    "secure": "An toàn",
    "min": "Tối thiểu:",
    "walletReady": "Ví đã sẵn sàng"
  },
  "th": {
    "notLoggedIn": "คุณยังไม่ได้เข้าสู่ระบบ",
    "accountNotFound": "ไม่พบบัญชีผู้ใช้",
    "failedLoad": "โหลดบัญชีของคุณไม่สำเร็จ",
    "loadingAccount": "กำลังโหลดบัญชี...",
    "title": "ฝากคริปโต",
    "subtitle": "เลือกวิธีฝากคริปโต",
    "secure": "ปลอดภัย",
    "min": "ขั้นต่ำ:",
    "walletReady": "กระเป๋าพร้อมใช้งาน"
  },
  "id": {
    "notLoggedIn": "Anda belum masuk.",
    "accountNotFound": "Akun pengguna tidak ditemukan.",
    "failedLoad": "Gagal memuat akun Anda.",
    "loadingAccount": "Memuat akun...",
    "title": "Deposit Kripto",
    "subtitle": "Pilih metode deposit kripto",
    "secure": "Aman",
    "min": "Min.:",
    "walletReady": "Dompet Siap"
  },
  "ms": {
    "notLoggedIn": "Anda belum log masuk.",
    "accountNotFound": "Akaun pengguna tidak ditemui.",
    "failedLoad": "Gagal memuatkan akaun anda.",
    "loadingAccount": "Memuatkan akaun...",
    "title": "Deposit Kripto",
    "subtitle": "Pilih kaedah deposit kripto anda",
    "secure": "Selamat",
    "min": "Min.:",
    "walletReady": "Dompet Sedia"
  },
  "ur": {
    "notLoggedIn": "آپ لاگ اِن نہیں ہیں۔",
    "accountNotFound": "صارف کا اکاؤنٹ نہیں ملا۔",
    "failedLoad": "آپ کا اکاؤنٹ لوڈ نہیں ہو سکا۔",
    "loadingAccount": "اکاؤنٹ لوڈ ہو رہا ہے...",
    "title": "کرپٹو جمع کریں",
    "subtitle": "اپنا کرپٹو جمع کرنے کا طریقہ منتخب کریں",
    "secure": "محفوظ",
    "min": "کم از کم:",
    "walletReady": "والیٹ تیار ہے"
  },
  "fa": {
    "notLoggedIn": "وارد حساب نشده‌اید.",
    "accountNotFound": "حساب کاربر پیدا نشد.",
    "failedLoad": "بارگذاری حساب شما ناموفق بود.",
    "loadingAccount": "در حال بارگذاری حساب...",
    "title": "واریز رمزارز",
    "subtitle": "روش واریز رمزارز را انتخاب کنید",
    "secure": "امن",
    "min": "حداقل:",
    "walletReady": "کیف پول آماده است"
  },
  "ha": {
    "notLoggedIn": "Ba ka shiga ba.",
    "accountNotFound": "Ba a sami asusun mai amfani ba.",
    "failedLoad": "An kasa loda asusunka.",
    "loadingAccount": "Ana loda asusu...",
    "title": "Ajiye Crypto",
    "subtitle": "Zaɓi hanyar ajiye crypto",
    "secure": "Amintacce",
    "min": "Mafi ƙaranci:",
    "walletReady": "Wallet ya shirya"
  },
  "yo": {
    "notLoggedIn": "O ko wọlé.",
    "accountNotFound": "A kò rí àkọọ́lẹ̀ olùlò.",
    "failedLoad": "A kò lè ṣí àkọọ́lẹ̀ rẹ.",
    "loadingAccount": "A ń ṣí àkọọ́lẹ̀...",
    "title": "Ìfipamọ́ Crypto",
    "subtitle": "Yan ọ̀nà ìfipamọ́ crypto rẹ",
    "secure": "Ó ní ààbò",
    "min": "Ó kéré jù:",
    "walletReady": "Apamọwọ ti ṣetan"
  },
  "zu": {
    "notLoggedIn": "Awungenanga ngemvume.",
    "accountNotFound": "I-akhawunti yomsebenzisi ayitholakalanga.",
    "failedLoad": "Yehlulekile ukulayisha i-akhawunti yakho.",
    "loadingAccount": "Ilayisha i-akhawunti...",
    "title": "Idiphozithi ye-Crypto",
    "subtitle": "Khetha indlela yakho yokufaka i-crypto",
    "secure": "Kuphephile",
    "min": "Ubuncane:",
    "walletReady": "Isikhwama sesilungile"
  },
  "am": {
    "notLoggedIn": "አልገቡም።",
    "accountNotFound": "የተጠቃሚ መለያ አልተገኘም።",
    "failedLoad": "መለያዎን መጫን አልተሳካም።",
    "loadingAccount": "መለያ በመጫን ላይ...",
    "title": "የክሪፕቶ ተቀማጭ",
    "subtitle": "የክሪፕቶ ተቀማጭ ዘዴዎን ይምረጡ",
    "secure": "ደህንነቱ የተጠበቀ",
    "min": "ዝቅተኛ:",
    "walletReady": "ዋሌት ዝግጁ ነው"
  },
  "so": {
    "notLoggedIn": "Ma aadan gelin.",
    "accountNotFound": "Akoonka isticmaalaha lama helin.",
    "failedLoad": "Lama soo dejin karin akoonkaaga.",
    "loadingAccount": "Akoonka waa la soo dejinayaa...",
    "title": "Dhigashada Crypto",
    "subtitle": "Dooro habka dhigashada crypto",
    "secure": "Ammaan",
    "min": "Ugu yaraan:",
    "walletReady": "Wallet-ku waa diyaar"
  },
  "rw": {
    "notLoggedIn": "Ntabwo winjiye.",
    "accountNotFound": "Konti y’umukoresha ntiyabonetse.",
    "failedLoad": "Ntibishobotse gufungura konti yawe.",
    "loadingAccount": "Konti iri gufunguka...",
    "title": "Kubitsa Crypto",
    "subtitle": "Hitamo uburyo bwo kubitsa crypto",
    "secure": "Bifite umutekano",
    "min": "Nibura:",
    "walletReady": "Wallet iriteguye"
  },
  "lg": {
    "notLoggedIn": "Tonnyingidde.",
    "accountNotFound": "Akaunti y’omukozesa tezuuliddwa.",
    "failedLoad": "Tekisobose kuteeka akaunti yo.",
    "loadingAccount": "Akaunti etikkibwa...",
    "title": "Okuteeka Crypto",
    "subtitle": "Londa engeri y’okuteekamu crypto",
    "secure": "Kirina obukuumi",
    "min": "Ekisinga obutono:",
    "walletReady": "Wallet yeetegefu"
  },
  "af": {
    "notLoggedIn": "Jy is nie aangemeld nie.",
    "accountNotFound": "Gebruikersrekening nie gevind nie.",
    "failedLoad": "Kon nie jou rekening laai nie.",
    "loadingAccount": "Rekening laai...",
    "title": "Kripto-deposito",
    "subtitle": "Kies jou kripto-depositometode",
    "secure": "Veilig",
    "min": "Min.:",
    "walletReady": "Beursie gereed"
  }
};

const getSavedLanguage = () => {
  try {
    return localStorage.getItem("language") || "en";
  } catch {
    return "en";
  }
};

export default function DepositCrypto() {
  const navigate = useNavigate();
  const [language, setLanguage] = useState(getSavedLanguage);

  useEffect(() => {
    const updateLanguage = () => setLanguage(getSavedLanguage());
    window.addEventListener("languageChanged", updateLanguage);
    window.addEventListener("storage", updateLanguage);
    return () => {
      window.removeEventListener("languageChanged", updateLanguage);
      window.removeEventListener("storage", updateLanguage);
    };
  }, []);

  const t = TRANSLATIONS[language] || TRANSLATIONS.en;

  const [userData, setUserData] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [error, setError] = useState("");

  /*
  |--------------------------------------------------------------------------
  | LOAD USER
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    loadCurrentUser();
  }, []);

  const loadCurrentUser = async () => {
    try {
      setLoadingUser(true);
      setError("");

      const savedUsername =
        localStorage.getItem("username");

      if (!savedUsername) {
        setError("notLoggedIn");
        setLoadingUser(false);
        return;
      }

      const q = query(
        collection(db, "users"),
        where(
          "username",
          "==",
          savedUsername
        )
      );

      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        setError("accountNotFound");
        setLoadingUser(false);
        return;
      }

      const userDoc = snapshot.docs[0];

      setUserData({
        id: userDoc.id,
        ...userDoc.data(),
      });

      setLoadingUser(false);
    } catch (err) {
      console.error(
        "Load user error:",
        err
      );

      setError("failedLoad");

      setLoadingUser(false);
    }
  };

  /*
  |--------------------------------------------------------------------------
  | GET EXISTING WALLET
  |--------------------------------------------------------------------------
  */

  const getExistingWalletAddress = (method) => {
    if (!method || !userData) {
      return "";
    }

    const oldAddress =
      userData?.[method.field];

    if (
      oldAddress &&
      String(oldAddress).trim()
    ) {
      return String(oldAddress).trim();
    }

    const walletAddress =
      userData?.cryptoWallets?.[
        method.walletKey
      ]?.address;

    if (
      walletAddress &&
      String(walletAddress).trim()
    ) {
      return String(walletAddress).trim();
    }

    return "";
  };

  /*
  |--------------------------------------------------------------------------
  | OPEN WALLET PAGE
  |--------------------------------------------------------------------------
  */

  const openWalletPage = (method) => {
    const existingAddress =
      getExistingWalletAddress(method);

    navigate("/crypto-wallet", {
      state: {
        method,
        existingAddress,
      },
    });
  };

  /*
  |--------------------------------------------------------------------------
  | LOADING
  |--------------------------------------------------------------------------
  */

  if (loadingUser) {
    return (
      <div className="deposit-page">
        <div className="deposit-loading">
          <div className="deposit-spinner" />

          <p>
            {t.loadingAccount}
          </p>
        </div>
      </div>
    );
  }

  /*
  |--------------------------------------------------------------------------
  | RENDER
  |--------------------------------------------------------------------------
  */

  return (
    <div className="deposit-page">

      <div className="deposit-container">

        {/* HEADER */}

        <div className="deposit-header">

          <button
            className="deposit-back-btn"
            type="button"
            onClick={() => navigate(-1)}
          >
            ←
          </button>

          <div className="deposit-title-wrap">

            <h1 className="deposit-title">
              {t.title}
            </h1>

            <p className="deposit-subtitle">
              {t.subtitle}
            </p>

          </div>

          <div className="deposit-security">

            <span className="deposit-security-dot" />

            {t.secure}

          </div>

        </div>

        {/* ERROR */}

        {error && (
          <div className="deposit-alert deposit-error">

            <span>!</span>

            <p>
              {t[error] || error}
            </p>

            <button
              type="button"
              onClick={() => setError("")}
            >
              ×
            </button>

          </div>
        )}

        {/* DEPOSIT METHODS */}

        <div className="deposit-method-list">

          {DEPOSIT_METHODS.map((method) => {

            const existingAddress =
              getExistingWalletAddress(method);

            return (
              <button
                key={method.id}
                type="button"
                className={`deposit-method ${method.className}`}
                onClick={() =>
                  openWalletPage(method)
                }
              >

                <div className="method-left">

                  <div className="method-icon">

                    <CoinLogo
                      type={method.coin}
                    />

                  </div>

                  <div className="method-info">

                    <strong>
                      {method.name}
                    </strong>

                    <span>
                      {method.network}
                    </span>

                  </div>

                </div>

                <div className="method-right">

                  <div>
                    {t.min} ${method.min}
                  </div>

                  {existingAddress && (
                    <span className="wallet-ready">
                      ✓ {t.walletReady}
                    </span>
                  )}

                </div>

              </button>
            );
          })}

        </div>

      </div>

    </div>
  );
}
